import React, {useState, useEffect, useContext} from 'react'
import { observer } from 'mobx-react-lite'
import axiosService from '../../../../../../utils/AxiosService'
import { ArrowRight } from 'react-bootstrap-icons'
import CommentItemSidebar from './CommentItemsSidebar'
import CommentLocation from '../../../../../../models/CommentLocation'
import { useParams } from 'react-router-dom'
import { SharedCampaignContext } from '../../../../../../contexts/Advertiser/SharedCampaignContext'

export default observer(function CommentsSidebar({ onClose }) {
  const { selectedUpload } = useContext(SharedCampaignContext)
  const [commentsShowing, setCommentsShowing] = useState('active')
  const [locations, setLocations] = useState([])

  const getCommentLocations = () => {
    setLocations([])
    axiosService.get(
      `/api/advertiser/campaign_share/draft_uploads/${selectedUpload.id}/draft_comment_locations`,
      { params: { location_filter: commentsShowing, for_sidebar: true } }
    )
      .then(newLocations => setLocations(newLocations.map(location => new CommentLocation(location))))
      .catch(error => console.log(error))
  }

  useEffect(() => getCommentLocations(), [selectedUpload.id, commentsShowing])


  return (
    <div className='fixed top-0 right-0 w-[440px] h-full bg-white dark:bg-rb-dark-mode z-50 flex flex-col shadow-[-4px_0_10px_-1px_rgba(0,0,0,0.1)]'>
      <div className='h-full flex flex-col'>

        <div className="p-4 px-6 flex justify-between items-center">
          <h2 className='font-bold text-lg dark:text-white'>Comments</h2>
          <button className='flex gap-1 items-center p-2 rounded-md hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter dark:text-white'>
            <span
              className="font-bold"
              onClick={onClose}
            >Back</span>
            <ArrowRight className='text-lg'/>
          </button>
        </div>

        <div className="px-6">
          <div className='border-b-1 dark:border-rb-dark-mode-lighter flex flex-start gap-2'>
            <button onClick={() => setCommentsShowing('active') } className={`${commentsShowing === 'active' ? 'text-rb-green dark:text-rb-green border-b-1 border-rb-green dark:border-rb-green p-2' : 'p-2 dark:text-white'}`}>Active</button>
            <button onClick={() => setCommentsShowing('resolved')} className={`${commentsShowing === 'resolved' ? 'text-rb-green dark:text-rb-green border-b-1 border-rb-green dark:border-rb-green p-2' : 'p-2 dark:text-white'}`}>Resolved</button>
            <button onClick={() => setCommentsShowing('all')} className={`${commentsShowing === 'all' ? 'text-rb-green dark:text-rb-green border-b-1 border-rb-green dark:border-rb-green p-2' : 'p-2 dark:text-white'}`}>All</button>
          </div>
        </div>

        <div className='px-6 flex-grow overflow-y-auto pb-4'>
          { locations.map(location => <CommentItemSidebar key={location.id} location={location}/>) }
        </div>

      </div>
    </div>
  )
})
